<template>
  <div class="cockpit-layout">
    <header v-if="isLoggedIn" class="header">
      <CockpitNavigation />
      <UserNavigation />
    </header>
    <hr class="divider" />
    <main class="main">
      <slot />
    </main>
    <footer v-if="useFooter" class="footer">
      <div class="links">
        <ButtonSecondary
          :label="t('common.footer.links.imprint.label')"
          :href="t('common.footer.links.imprint.link')"
          target="_blank"
        />
        <ButtonSecondary
          :label="t('common.footer.links.privacy.label')"
          :href="t('common.footer.links.privacy.link')"
          target="_blank"
        />
        <ButtonSecondary
          :label="t('common.footer.links.agb.label')"
          :href="t('common.footer.links.agb.link')"
          target="_blank"
        />
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import CockpitNavigation from '~/cockpit/layout-components/CockpitNavigation.vue';
import UserNavigation from '~/cockpit/layout-components/UserNavigation.vue';
import { injectStrict } from '~/common/inject';
import { AppDataInjectionKey } from '~/common/useAppData';
import ButtonSecondary from '~/common/buttons/ButtonSecondary.vue';
import { useI18n } from 'vue-i18n';

defineProps<{
  useFooter?: boolean;
}>();

const { t } = useI18n();
const { isLoggedIn } = injectStrict(AppDataInjectionKey);
</script>
